import React, { useState, useEffect } from 'react';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import { FaChalkboardTeacher, FaTools, FaCamera, FaTrash } from 'react-icons/fa';
import axios from 'axios';

const Modifier_formation = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const { formation_id } = location.state || {}; // Obtention de l'ID de la formation
    const navigate = useNavigate();

    const user_id = localStorage.getItem('user_id');

    const [formationData, setFormationData] = useState({
        nom: '',
        prix: '',
        periode: '',
        option: '',
        date: '',
        lieu: '',
    });

    const [photo, setPhoto] = useState(null);
    const [photoPreview, setPhotoPreview] = useState('');
    const [currentPhotoUrl, setCurrentPhotoUrl] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [initialFormationData, setInitialFormationData] = useState(formationData);

    useEffect(() => {
        const fetchFormationData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/formation-info/${formation_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setFormationData({
                        nom: data.nom,
                        prix: data.prix,
                        periode: data.periode,
                        option: data.option,
                        lieu: data.lieu,
                        date: data.date || '',
                    });
                    setInitialFormationData(data);
                    
                    // Mettre à jour l'URL de la photo actuelle
                    if (data.photo) {
                        setCurrentPhotoUrl(process.env.REACT_APP_HOTE + data.photo);
                        setPhotoPreview(process.env.REACT_APP_HOTE + data.photo);
                    }
                } else {
                    console.error('Erreur lors de la récupération des données de la formation');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };
        fetchFormationData();
    }, [formation_id]);

    const handlePhotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Vérifier la taille du fichier (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                alert('La taille de l\'image ne doit pas dépasser 5MB');
                return;
            }

            // Vérifier le type de fichier
            if (!file.type.startsWith('image/')) {
                alert('Veuillez sélectionner une image valide');
                return;
            }

            setPhoto(file);
            
            // Créer un preview de l'image
            const reader = new FileReader();
            reader.onload = (e) => {
                setPhotoPreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemovePhoto = () => {
        setPhoto(null);
        setPhotoPreview(currentPhotoUrl); // Revenir à la photo originale
        document.getElementById('photo-upload').value = ''; // Réinitialiser l'input file
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            // Si une nouvelle photo est sélectionnée, utiliser FormData
            if (photo) {
                const formData = new FormData();
                formData.append('nom', formationData.nom);
                formData.append('prix', formationData.prix);
                formData.append('periode', formationData.periode);
                formData.append('option', formationData.option);
                formData.append('lieu', formationData.lieu);
                formData.append('date', formationData.date);
                formData.append('photo', photo);

                const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-formation/${formation_id}/`, {
                    method: 'POST',
                    body: formData,
                    // Note: Ne pas définir Content-Type pour FormData, le navigateur le fera automatiquement
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error('Erreur:', errorData);
                    alert('Une erreur est survenue: ' + errorData.error);
                } else {
                    navigate(`/Liste-formation`);
                }
            } else {
                // Si pas de nouvelle photo, utiliser JSON
                const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-formation/${formation_id}/`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formationData),
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error('Erreur:', errorData);
                    alert('Une erreur est survenue: ' + errorData.error);
                } else {
                    navigate(`/Liste-formation`);
                }
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            alert('Erreur réseau : ' + error.message);
        }
    };

    const handleShowModal = (event) => {
        event.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirmCancel = () => {
        setFormationData(initialFormationData);
        setPhoto(null);
        setPhotoPreview(currentPhotoUrl);
        setShowModal(false);
    };

    const handleReset = () => {
        setFormationData(initialFormationData);
        setPhoto(null);
        setPhotoPreview(currentPhotoUrl);
        document.getElementById('photo-upload').value = '';
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Formation")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaChalkboardTeacher size={25} className="mr-2" />
                                Modification de la formation {initialFormationData.nom}
                            </h2>
                            <small>Administration des formations.</small>
                            <small id="hbreadcrumb" className="d-flex justify-content-end">
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/Liste-formation`}>Formations</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Modification de la formation {initialFormationData.nom}</li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {/* Formulaire responsive */}
                    <div className="col-lg-8 col-lg-10 mx-auto mt-5 mb-3">
                        <div className="ibox-content">
                            <div className="hpanel">
                                <div className="panel-body">
                                    <form className="m-t" role="form" onSubmit={handleSubmit}>
                                        <div className="row">
                                            {/* Photo de la formation */}
                                            <div className="form-group col-12">
                                                <label>Photo de la formation</label>
                                                <div className="d-flex align-items-center mb-3">
                                                    {photoPreview && (
                                                        <div className="position-relative me-3">
                                                            <img 
                                                                src={photoPreview} 
                                                                alt="Preview" 
                                                                className="img-thumbnail"
                                                                style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                            />
                                                            {photo && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm position-absolute"
                                                                    style={{ top: '5px', right: '5px' }}
                                                                    onClick={handleRemovePhoto}
                                                                >
                                                                    <FaTrash size={12} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div>
                                                        <label 
                                                            htmlFor="photo-upload" 
                                                            className="btn btn-outline-primary btn-sm mb-2"
                                                        >
                                                            <FaCamera className="mr-2" />
                                                            {photo ? 'Changer la photo' : 'Ajouter une photo'}
                                                        </label>
                                                        <input
                                                            id="photo-upload"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handlePhotoChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <div className="text-muted small">
                                                            Formats acceptés: JPG, PNG, GIF (max 5MB)
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Nom de la formation */}
                                            <div className="form-group col-12">
                                                <label>Nom*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    required
                                                    name="nom"
                                                    value={formationData.nom}
                                                    onChange={(e) => setFormationData({ ...formationData, nom: e.target.value })}
                                                />
                                            </div>
                                            {/* Prix de la formation */}
                                            <div className="form-group col-12">
                                                <label>Prix*</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    required
                                                    name="prix"
                                                    value={formationData.prix}
                                                    onChange={(e) => setFormationData({ ...formationData, prix: e.target.value })}
                                                />
                                            </div>
                                            {/* Description avec Quill */}
                                            <div className="form-group col-12">
                                                <label>Période</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="periode"
                                                    required
                                                    name="periode"
                                                    value={formationData.periode}
                                                    onChange={(e) => setFormationData({ ...formationData, periode: e.target.value })}
                                                />
                                            </div>
                                            <div className="form-group col-12">
                                                <label>Option</label>
                                                <input
                                                    className="form-control"
                                                    name="option"
                                                    placeholder="Option"
                                                    required
                                                    value={formationData.option}
                                                    onChange={(e) => setFormationData({ ...formationData, option: e.target.value })}
                                                />
                                            </div>
                                            <div className="form-group col-12">
                                                <label>Lieu*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Lieu"
                                                    required
                                                    name="lieu"
                                                    value={formationData.lieu}
                                                    onChange={(e) => setFormationData({ ...formationData, lieu: e.target.value })}
                                                />
                                            </div>
                                            {/* Date */}
                                            <div className="form-group col-12">
                                                <label>Date fin*</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    required
                                                    name="date"
                                                    value={formationData.date?.split('/').reverse().join('-') || ""}
                                                    min={new Date().toISOString().split('T')[0]}
                                                    onChange={(event) => {
                                                        const dateIso = event.target.value; // Format ISO (YYYY-MM-DD)
                                                        const [year, month, day] = dateIso.split('-');
                                                        const dateFr = `${day}/${month}/${year}`; // Format FR (DD/MM/YYYY)

                                                        setFormationData({ ...formationData, date: dateFr });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {/* Boutons */}
                                        <div className="text-center mt-4">
                                            <Link to='/Liste-formation' className="btn btn-default mr-2">Annuler</Link>
                                            <button type="button" className="btn btn-default mr-2" onClick={handleReset}>Effacer</button>
                                            <button type="submit" className="btn btn-success">Enregistrer</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de confirmation */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Êtes-vous sûr de vouloir annuler les modifications ?</Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseModal}>Non</button>
                    <button className="btn btn-success" onClick={handleConfirmCancel}>Oui</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Modifier_formation;